import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getAnalisysTypes = () => async (dispatch) => {
    dispatch({
        type: 'ANALISYSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisystype/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYSTYPE_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYSTYPE_NOT_LOADING'
        })
    }
}

export const getAnalisysType = (analisysType) => async (dispatch) => {
    dispatch({
        type: 'ANALISYSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisystype/get/'+ analisysType, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYSTYPE_GET_SUCCESS',
                payload: data.analisysType
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYSTYPE_NOT_LOADING'
        })
    }
}

export const addAnalisysType = (analisysTypedata) => async (dispatch) => {
    dispatch({
        type: 'ANALISYSTYPE_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/analisystype/register', analisysTypedata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'ANALISYSTYPE_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYSTYPE_NOT_LOADING'
        })
    }
}

export const editAnalisysType = (analisysTypedata, idAnalisysType) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/analisystype/edit/' + idAnalisysType, analisysTypedata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'ANALISYSTYPE_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYSTYPE_ERROR'
        })
    }
}

export const removeAnalisysType = (analisysType) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/analisystype/remove/' + analisysType, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'ANALISYSTYPE_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYSTYPE_NOT_LOADING'
        })
    }
}

export const resetAnalisysType = () => async (dispatch) => {
    dispatch({
        type: 'ANALISYSTYPES_RESET'
    })
}